import videojs from 'video.js';

export class AssignmentPluginStub extends videojs.getPlugin('plugin') {
    constructor(player, options) {
        super(player, options);

        player.loader().onLoadPlayCover(onLoadPlayCover.bind(player));
    }
}

function shouldLoad(presentationId, playCoverData, presentationData) {
    return playCoverData.assignmentData !== null;
}

async function onLoadPlayCover(presentationId, playCoverData, presentationData) {
    const player = this;

    if (shouldLoad(...arguments)) {
        if (!videojs.getPlugin('assignment')) {
            const { AssignmentPlugin } = await import(/* webpackChunkName: 'assignment' */ './assignment.js');
            player.registerPlugin('assignment', AssignmentPlugin);

            player.assignment().init({
                assignmentData: playCoverData.assignmentData,
                title: playCoverData.title
            });
        }
    }
}